import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";

const RadioButtons = ({ letter, title, value, handleChange, ml, disabled }) => {
  return (
    <Box>
      {title && (
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            mt: 2,
            textIndent: "-1.1rem",
            paddingLeft: "1.2rem",
          }}
          gutterBottom
        >
          {title}
        </Typography>
      )}
      <FormControl sx={{ my: 1, ml: ml || 2.2 }}>
        <RadioGroup
          row
          value={value}
          onChange={handleChange}
          disabled={disabled}
        >
          <FormControlLabel
            value={true}
            control={<Radio disabled={disabled} />}
            label="Yes"
          />
          <FormControlLabel
            value={false}
            control={<Radio disabled={disabled} />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default RadioButtons;
